/* eslint-disable no-console */
import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { auth0Config } from './auth0Config';

interface Auth0ProviderWrapperProps {
  children: React.ReactNode;
}

function Auth0ProviderWrapper({ children }: Auth0ProviderWrapperProps) {
  const navigate = useNavigate();
  const onRedirectCallback = (appState) => {
    // eslint-disable-next-line no-console
    console.log('Auth0 redirect callback - appState:', appState);
    const redirectPath = appState?.returnTo || '/farms';
    navigate(redirectPath, {
      replace: true,
    });
  };
  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: auth0Config.redirectUri,
        audience: auth0Config.audience,
        scope: 'openid email offline_access profile',
      }}
      cacheLocation="localstorage"
      useRefreshTokens
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
}

export default Auth0ProviderWrapper;
